
// import React, { CSSProperties, useCallback, useEffect, useMemo, useRef, useState } from "react";
// import { useTranslation } from "react-i18next";
// import { useLocation } from 'react-router';
// import { colors, css, fonts, frames, glyphs, useMediaQuery } from "../../../../Styles";
// import { ButtonList, PageHeader, NewSelect } from "../../../../Components";
// import { ButtonTypes, NewFieldStyles, ListData_ValueTypes, ListStyle_Types, TableStyles_Types } from "../../../../Definitions";
// import * as XLSX from 'xlsx';

// // Table
// import { GenericDataParameters } from "../../../../Components/Tables/_Tables/useColumnConstructor";
// import { useEditableColumnConstructor } from "../../../../Components/Tables/_Tables/useEditableColumnConstructor";
// import { getCoreRowModel, getFilteredRowModel, getSortedRowModel, useReactTable } from "@tanstack/react-table";
// import { ReactiveTable } from "../../../../Components/Tables/reactiveTableRenderer";

// // TODO
// import { ArchivedReport, TestData as ArchivedReportData, FilterParameter } from "../../../../Assets/TestData/reports";
// import { getAnimalDatas, Animals } from '../../../../Assets/TestData/animalData';
// import { Condition, ConditionData as conditionData } from '../../../../Assets/TestData/conditions';
// import { AnimalGroupData as groupData } from '../../../../Assets/TestData/animalGroups';
// import { LocationData as locationData } from '../../../../Assets/TestData/locations';
// import { Pages } from "../../../../Navigation/Routers/root";

// const createConditionTableDivStyleFunction = (conditionData: Condition[]) => {
//   const colorTagFromName = (name: string|number) => {return conditionData.find(condition => condition.conditionName === name)?.conditionColorTag} 
//   return (name?: string | number):CSSProperties|undefined => { if (!name) {return undefined} return {backgroundColor: colorTagFromName(name), ...css.colorTag, ...fonts.header, ...fonts.fontSize4, color: colors.whitePrimary}}
//   }

export default function Report() {
  return(<></>)
}

// export default function Report() {
//   const {t} = useTranslation()
//   let location = useLocation();
//   const [selectedReportId, setSelectedReportId] = useState<number>();
//   const [showReport, setShowReport] = useState<ArchivedReport | undefined>(undefined);
//   const hideBtnText = useMediaQuery(`(max-width: 450px)`);
//   const hideBtns = useMediaQuery(`(max-width: 1000px)`);
//   const [AnimalData, setAnimalData] = useState<Animals[]>([]);
//   const divStyleOverride = useMemo(() => (createConditionTableDivStyleFunction(conditionData)),[])
//   const [isExcelData, setExcelData] = useState(false);
//   const [isCsvData, setCsvData] = useState(false)

//   // #region | Select the report to view
//   // Get options from ArchivedReportData and return the first to view if there isn't any selected from the archive page.
//   const reportOptions = useMemo(() => {
//     const options = ArchivedReportData.map(report => ({
//       label: report.name,
//       id: report.reportNo
//     }));
//     if (!showReport && location.state?.params?.selected) {
//       setSelectedReportId(location.state.params.selected);
//     } else if (!showReport && options.length) {
//       setSelectedReportId(options[0].id);
//     }
//     return options;
//   }, [showReport, location.state]);

//   useEffect(() => {
//     if (location.state?.params?.selected && !showReport && ArchivedReportData) {
//       setSelectedReportId(location.state.params.selected);
//     }
//   }, [location.state, selectedReportId, showReport]);
//   // #endregion

//   // #region | Data handling
//   useEffect(()=> {
//     const report = ArchivedReportData.find((report) => report.reportNo === selectedReportId)
//     if (!report) return;
//     setShowReport(report)

//     // Find all data withing time periode
//     let animalData = getAnimalDatas();
//     //let timefiltered_Data = animalData.filter(e => e.birthDate&&report.dateEnd?(e.birthDate.getTime() > new Date(report.dateStart).getTime() && e.birthDate.getTime() < new Date(report.dateEnd).getTime()):e)
//     let timefiltered_Data = animalData;
//     // console.log("timeFilter ???", animalData.length, timefiltered_Data.length);

//     // Filtering data
//     var parameret_Filtered: Animals[] = [];
//     if (report.filterParameter && report.filterParameter.length > 0) {
//       var fullData = timefiltered_Data;
      
//       report.filterParameter.forEach(filter => {
//         var mainFiltered:Animals[] = fullData.filter(e => e[filter.main.key] = filter.main.value);
//         if (mainFiltered.length > 0) {
//           var subFiltered:Animals[] = [];
//           if (filter.sub) {
//             subFiltered = mainFiltered.reduce((acc:Animals[], item) => {
//               Object.entries(filter.sub as FilterParameter).forEach(([_key, value]) => {
//                 var key = _key as Extract<keyof FilterParameter, string>;
//                 if (item.hasOwnProperty(key) && item[key] !== undefined) {
//                   if (value.includes(item[key] as never)) acc.push(item)
//                 }
//               })
//               return acc
//             }, [])
//           }
//           else subFiltered = mainFiltered
//           parameret_Filtered = parameret_Filtered.concat(subFiltered)
//           fullData = fullData.filter(e => parameret_Filtered.findIndex(x => x.animalId === e.animalId) < 0)
//         }
//       })
//     }
//     else parameret_Filtered = timefiltered_Data
//     // save filtered data
//     setAnimalData(parameret_Filtered);
//   },[selectedReportId])
//   // #endregion

//   // #region | Creating the table view
//   const tableData = useMemo(() => (AnimalData.map((animal, index) => {
//     const _conditionId = conditionData.find(cond => cond.conditionId === animal.conditionId) || {conditionName: t("noData", {defaultValue: "No Data"}), colorTag: colors.greyPrimary}
//     const _groupId = groupData.find(group => group.groupId === animal.groupId) || {groupName: t("noData", {defaultValue: "No Data"})}
//     const _locationId = locationData.find(loc => loc.locationId === animal.locationId) || {locationName: t("noData", {defaultValue: "No Data"})}

//     return {
//       id: index+1,
//       animalId: animal.animalId,
//       conditionId: _conditionId.conditionName,
//       groupId: _groupId.groupName,
//       locationId: _locationId.locationName
//     };
//   })),[AnimalData])

//   const accessorData = useMemo<GenericDataParameters[]>(() => {
//     var tabel:GenericDataParameters[] = []

//     const existingColumns = new Set<string>();

//     // Datalevels
//     if (showReport && showReport.dataLevel) {
//       const level = showReport.dataLevel;
//       if (!existingColumns.has(level)) {
//         existingColumns.add(level);
//         tabel.push({
//           headerValue: 
//             level === "animalId" ? t("params.animal", {defaultValue: "animal"})
//             : level === "groupId" ? t("params.group", {defaultValue: "group"})
//             : level === "locationId" ? t("params.location", {defaultValue: "location"})
//             : "",
//           accessor: level,
//           type: ListData_ValueTypes.String,
//           sort: true,
//         });
//       }
//     }

//     // Filterparameters
//     if (showReport && showReport.filterParameter) {
//       showReport.filterParameter.forEach((filter) => {
        
//         // Filterparameters mains
//         if (filter.main && filter.main.key && !existingColumns.has(filter.main.key)) {
//           existingColumns.add(filter.main.key);
//           tabel.push({
//             headerValue: ( 
//               filter.main.key === "conditionId" ? t("params.condition", {defaultValue: "condition"}) 
//               : filter.main.key === "groupId" ? t("params.group", {defaultValue: "group"})
//               : filter.main.key === "locationId" ? t("params.location", {defaultValue: "location"}) 
//               : "" 
//             ),
//             accessor: filter.main.key,
//             type: (
//               filter.main.key === "conditionId" ? ListData_ValueTypes.Div
//               : ListData_ValueTypes.String
//             ),
//             sort: true,
//             divStyleOverride
//           });
//         }
        
//         // Filterparameters subs
//         if (filter.sub) {
//           if (filter.sub.conditionId && !existingColumns.has("conditionId")) {
//             existingColumns.add("conditionId");
//             tabel.push({
//               headerValue: t("params.condition", {defaultValue: "condition"}),
//               accessor: "conditionId",
//               type: ListData_ValueTypes.Div,
//               sort: true,
//               divStyleOverride
//             });
//           }
//           if (filter.sub.groupId && !existingColumns.has("groupId")) {
//             existingColumns.add("groupId");
//             tabel.push({
//               headerValue: t("params.group", {defaultValue: "group"}),
//               accessor: "groupId",
//               type: ListData_ValueTypes.String,
//               sort: true,
//             });
//           }
//           if (filter.sub.locationId && !existingColumns.has("locationId")) {
//             existingColumns.add("locationId");
//             tabel.push({
//               headerValue: t("params.location", {defaultValue: "location"}),
//               accessor: "locationId",
//               type: ListData_ValueTypes.String,
//               sort: true,
//             });
//           }
//         }
//       });
//     }

//     // Dataparameters
//     if (showReport && showReport.dataParameter) {
//       showReport.dataParameter.forEach((dataparam) => {
//         if (!existingColumns.has(dataparam)) {
//           existingColumns.add(dataparam);
//           tabel.push({
//             headerValue: 
//               dataparam === "conditionId" ? t("params.condition", {defaultValue: "condition"})
//               : dataparam === "groupId" ? t("params.group", {defaultValue: "group"})
//               : dataparam === "locationId" ? t("params.location", {defaultValue: "location"})
//               : "",
//             accessor: dataparam,
//             type: (
//               dataparam === "conditionId" ? ListData_ValueTypes.Div
//               : ListData_ValueTypes.String
//             ),
//             sort: true,
//             divStyleOverride
//           });
//         }
//       });
//     }

//     return tabel;
//   }, [divStyleOverride, showReport]);

//   const columns = useEditableColumnConstructor({
//     accessorData: [...accessorData], 
//     tableStyle: TableStyles_Types.primaryTable,
//     canEdit: false
//   });

//   const table = useReactTable({
//     columns,
//     data: tableData,
//     getCoreRowModel: getCoreRowModel(),
//     getFilteredRowModel: getFilteredRowModel(),
//     getSortedRowModel: getSortedRowModel(),

//   })
  
//   const reactiveTable = useMemo(() => {
//     if (tableData.length!==0) {
//       return ReactiveTable({
//         table, 
//         tableType: TableStyles_Types.primaryTable, 
//         emptyText: t("reportPages.report.noReport", {defaultValue: "No report found"}), 
//         renderFooter: false
//       })
//     }
//   }, [table, tableData.length, t])

//    // #endregion

//   // #region | Download PDF
//   const tableRef = useRef<HTMLDivElement>(null);

//   const handlePrint = () => {
//     console.log("print")
//     // if (tableRef.current) {
//     //   const printContent = tableRef.current.innerHTML;
//     //   const originalContent = document.body.innerHTML;
  
//     //   document.body.innerHTML = printContent;
//     //   window.print();
//     //   document.body.innerHTML = originalContent;
//     //   window.location.reload();
//     // }
//   };
//   // #endregion

//   // #region | Download CSV
//   const exportToCSV = useCallback((data: { [key: string]: any }[], filename = showReport?.name+'.csv') => {
//     if (!data.length) return;
  
//     const headers = accessorData
//       .map(col => col.headerValue);
  
//     const rows = data.map(row =>
//       accessorData
//         .map(col => row[col.accessor] ?? "")
//     );
  
//     const csvContent =
//       'data:text/csv;charset=utf-8,' +
//       [headers.join(','), ...rows.map(row => row.join(','))].join('\n');
  
//     const encodedUri = encodeURI(csvContent);
//     const link = document.createElement('a');
//     link.setAttribute('href', encodedUri);
//     link.setAttribute('download', filename);
//     document.body.appendChild(link);
//     link.click();
//     document.body.removeChild(link);
//   }, [accessorData, showReport?.name]);
  
//   const handleExportCSV = () => {
//     setCsvData(true);
//   }
//   // #endregion

//   // #region | Download Excel
//   const exportToExcel = useCallback((data: { [key: string]: any }[], filename = showReport?.name+'.xlsx') => {
//     if (!data.length) return;
  
//     const headers = accessorData
//       .map(col => col.headerValue);
  
//     const rows = data.map(row =>
//       accessorData
//         .map(col => row[col.accessor] ?? "")
//     );
  
//     const worksheet = XLSX.utils.aoa_to_sheet([headers, ...rows]);
//     worksheet["!cols"] = accessorData.map(() => ({ wpx: 100 }));
//     const workbook = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(workbook, worksheet, showReport?.name);
  
//     XLSX.writeFile(workbook, filename);
//   }, [accessorData, showReport?.name]);

//   const handleExportExcel = () => {
//     setExcelData(true); 
//   };
//   // #endregion
  
//   useEffect(() => {
//     if (isExcelData) {
//       exportToExcel(tableData);
//       setExcelData(false);
//     } else if (isCsvData) {
//       exportToCSV(tableData)
//       setCsvData(false)
//     }
//   }, [exportToCSV, exportToExcel, isCsvData, isExcelData, tableData]);

//   return (
//     <frames.Page_inner>
//       <frames._page_inner_header>
//         <div style={{display: "flex", flexDirection: "row", alignItems: "start", justifyContent: "space-between", gap: "20px"}}>
//           <div>
//             <PageHeader topHeader={t(`menuHeaders.${Pages.reports}`, {defaultValue: "reports"})}/>
//             <NewSelect
//               options={reportOptions}
//               // placeholder={t("select", {defaultValue: "Select"})}
//               onChange={(e) => setSelectedReportId(Number(e?.id ?? 0))}
//               fieldOverrides={{
//                 fieldStyle: NewFieldStyles.greyDarkPrimary
//               }}
//               valueOverrides={{
//                 defaultValue: reportOptions.find(option => option.label === showReport?.name)
//               }}
//             />
//           </div>
//           <ButtonList 
//             contents={[
//               t("reportPages.report.editReport", {defaultValue: "Edit Report"}), 
//               t("reportPages.report.unArchiveReport", {defaultValue: "Unarchive Report"}), 
//               t("reportPages.report.saveAsTemplate", {defaultValue: "Save as Template"})
//             ]}
//             buttonType={ButtonTypes.primaryButton}
//             overrides={{
//               baseButton: { ...( !hideBtns ? {...css.button_FitContent, minWidth: "none"} : {backgroundColor: colors.greyDarkSecondary})}
//             }}
//             listOverrides={{
//               listStyle: !hideBtns ? ListStyle_Types.horizontal : ListStyle_Types.vertical,
//             }}
//             responsiveOverrides={{
//               isResponsive: !hideBtns ? false : true,
//               popoverStyle: { backgroundColor: colors.greyDarkPrimary, padding: "20px", borderRadius: "10px", boxShadow: "0px 0px 5px 2px"+colors.blackPrimary+"4d" },
//               openContent: hideBtnText ? "" : t("buttons.options", {defaultValue: "options"})
//             }}
//           />
//         </div>
//       </frames._page_inner_header>
//       <frames._page_inner_content>
//           <div style={{height: "100%", width: "100%", display: "grid", gridAutoRows: "50px 1fr", boxSizing: "border-box"}}>
//             <div style={{ backgroundColor: "transparent", display: "flex", justifyContent: "end", padding: "0px 20px", gap: "5px"}}>
//                 <ButtonList 
//                   contents={[
//                     // t("buttons.print", {defaultValue: "print"}), 
//                     t("buttons.excel", {defaultValue: "excel"}), 
//                     t("buttons.csv", {defaultValue: "csv"})
//                   ]} 
//                   onClick={(i => {
//                     // if (i === 0) {handlePrint()}
//                     if (i === 0) {handleExportExcel()}
//                     if (i === 1) {handleExportCSV()}
//                   })}
//                   buttonType={ButtonTypes.tableButton}
//                   startEnhancers={[
//                     // glyphs.Close({}), 
//                     glyphs.Close({}), 
//                     glyphs.Close({})
//                   ]}
//                 />
//             </div>
//             <div ref={tableRef} style={{height: "100%", boxSizing: "border-box", position: "relative", backgroundColor: colors.greyLightSecondary, border: "5px solid "+colors.greyPrimary, borderRadius: "10px", overflow: "hidden"}}>
//               {reactiveTable}
//             </div>
//           </div>
//       </frames._page_inner_content>

//     </frames.Page_inner>
//   )
// }


